<template>
  <div>
    <h3>Registering</h3>
    <div data-form-block-id="0f30697b-15ce-ed11-b597-6045bd8c56d2"></div>
    <div id="dzBltBFsbzjnC-dTpQpwxkrtqb7eIgAkcatSFx6HMmh0"></div>
    <div
      class="d365-mkt-config"
      style="display:none"
      data-website-id="zBltBFsbzjnC-dTpQpwxkrtqb7eIgAkcatSFx6HMmh0"
      data-hostname="e715b07924f74693b0d37d9b3111a807.svc.dynamics.com"
    ></div>
    <!-- <meta
      type="xrm/designer/setting"
      name="layout-editable"
      value="marketing-designer-layout-editable"
    />
    <meta
      type="xrm/designer/setting"
      name="layout-max-width"
      value="600px"
      datatype="text"
      label="Layout max width"
    />
    <form
      id="containerc6f3031ec832f1679407144660"
      data-template-id="9ef1241d-01d9-4c8f-89f6-4f695895dcbf"
      data-container="true"
      style="null"
    >
      <div data-layout="true" tabindex="0">
        <div
          data-section="true"
          style="padding: 0px 10px;"
          class="emptyContainer"
        >
          <div
            style="display: flex;
            width: 100%;
        ;flex-wrap: wrap;"
            class="containerWrapper"
          >
            <div style="clear:both;"></div>
            <div
              id="containerde5dfffafeac481679407144660"
              data-container="true"
              class="columnContainer"
              data-container-width="100"
              style="display: block; min-height: 0px; min-width: 20px; width: calc(100% - 0px); box-sizing: border-box; flex-direction: column; padding: 0px 10px; float: left;  word-wrap: break-word; word-break: break-word; word-wrap: break-word; word-break: break-word;"
            ></div>
            <div style="clear:both;"></div>
          </div>
        </div>
        <div data-section="true" class="">
          <div
            style="display: flex;
            width: 100%;
        ;flex-wrap: wrap;"
          >
            <div style="clear:both;"></div>
            <div
              id="container55e839d81e5e681679407144660"
              data-container="true"
              class="columnContainer"
              data-container-width="50"
              style="display: block; min-height: 0px; min-width: 0px; width: calc(50% - 0px); box-sizing: border-box; padding: 10px; float: left;     word-wrap: break-word; word-break: break-word;    word-wrap: break-word; word-break: break-word;"
            >
              <div
                data-editorblocktype="Field-text"
                style="text-align: center;"
              >
                <div class="marketing-field" style="text-align: center;">
                  <div class="lp-form-field" style="text-align: left;">
                    <label
                      class="lp-ellipsis"
                      for="3f746946-34b4-442c-a677-e232cdd2bc40"
                      style=" font-weight: bold;"
                      title=""
                      >Fornavn</label
                    ><span style="font-size: 14px; text-align: center;"
                      ><span class="lp-required" style="text-align: center;"
                        >*</span
                      ></span
                    >
                    <input
                      id="3f746946-34b4-442c-a677-e232cdd2bc40"
                      v-model="firstname"
                      class="lp-form-fieldInput"
                      name="3f746946-34b4-442c-a677-e232cdd2bc40"
                      placeholder=""
                      required="required"
                      style="width:100%"
                      title=""
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              id="container489c3677729d781679407144660"
              data-container="true"
              class="columnContainer"
              data-container-width="50"
              style="display: block; min-height: 0px; min-width: 0px; width: calc(50% - 0px); box-sizing: border-box; padding: 10px; float: left;     word-wrap: break-word; word-break: break-word;    word-wrap: break-word; word-break: break-word;"
            >
              <div
                data-editorblocktype="Field-text"
                style="text-align: center;"
              >
                <div class="marketing-field" style="text-align: center;">
                  <div class="lp-form-field" style="text-align: left;">
                    <label
                      class="lp-ellipsis"
                      for="e1dfc514-f301-4cb2-855a-4c8fa8331207"
                      style=" font-weight: bold;"
                      title=""
                      >Etternavn</label
                    ><span style="font-size: 14px; text-align: center;"
                      ><span class="lp-required" style="text-align: center;"
                        >*</span
                      ></span
                    >
                    <input
                      id="e1dfc514-f301-4cb2-855a-4c8fa8331207"
                      v-model="lastname"
                      class="lp-form-fieldInput"
                      name="e1dfc514-f301-4cb2-855a-4c8fa8331207"
                      placeholder=""
                      required="required"
                      style="width:100%"
                      title=""
                      type="text"
                      value=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style="clear:both;"></div>
          </div>
        </div>

        <div data-section="true" style="padding: 0px;" class="">
          <div
            style="display: flex;
            width: 100%;
        ;flex-wrap: wrap;"
            class="containerWrapper"
          >
            <div style="clear:both;"></div>
            <div
              id="container0e7c4eb1cc07e1679407144660"
              data-container="true"
              class="columnContainer"
              data-container-width="50"
              style="display: block; min-height: 70px; min-width: 15px; width: calc(50% - 0px); box-sizing: border-box; flex-direction: column; padding: 10px; float: left;    word-wrap: break-word; word-break: break-word;   word-wrap: break-word; word-break: break-word;"
            >
              <div
                data-editorblocktype="Field-email"
                style="text-align: center;"
              >
                <div class="marketing-field" style="text-align: center;">
                  <div class="lp-form-field" style="text-align: left;">
                    <label
                      class="lp-ellipsis"
                      for="7f685ebb-7c54-4cff-a1bc-772562d25c38"
                      style=" font-weight: bold;"
                      title=""
                      >E-post</label
                    ><span style="font-size: 14px; text-align: center;"
                      ><span class="lp-required" style="text-align: center;"
                        >*</span
                      ></span
                    >
                    <input
                      id="7f685ebb-7c54-4cff-a1bc-772562d25c38"
                      v-model="email"
                      class="lp-form-fieldInput"
                      name="7f685ebb-7c54-4cff-a1bc-772562d25c38"
                      placeholder=""
                      required="required"
                      style="width:100%"
                      title=""
                      type="email"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              id="container030caabd6663f1679407144660"
              data-container="true"
              class="columnContainer"
              data-container-width="50"
              style="display: block; min-height: 70px; min-width: 15px; width: calc(50% - 0px); box-sizing: border-box; flex-direction: column; padding: 10px; float: left;    word-wrap: break-word; word-break: break-word;   word-wrap: break-word; word-break: break-word;"
            >
              <div
                data-editorblocktype="Field-text"
                style="text-align: center;"
              >
                <div class="marketing-field" style="text-align: center;">
                  <div
                    class="lp-form-field"
                    data-required-field="false"
                    style="text-align: left;"
                  >
                    <strong
                      ><label
                        class="lp-ellipsis"
                        for="f96c7cf6-34e1-ea11-a813-000d3a2109a6"
                        title=""
                        >Firma</label
                      ></strong
                    ><input
                      id="f96c7cf6-34e1-ea11-a813-000d3a2109a6"
                      class="lp-form-fieldInput"
                      name="f96c7cf6-34e1-ea11-a813-000d3a2109a6"
                      placeholder=""
                      style="width: 100%; box-sizing: border-box;"
                      title=""
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style="clear:both;"></div>
          </div>
        </div>
        <div data-section="true" class="">
          <div
            style="
            display: flex;
            width: 100%;
        ;flex-wrap: wrap;"
          >
            <div style="clear:both;"></div>
            <div
              id="container4d4758d4f70ba81679407144660"
              data-container="true"
              class="columnContainer"
              data-container-width="100"
              style="display: block; min-height: 0px; min-width: 0px; width: calc(100% - 0px); box-sizing: border-box; padding: 0px 10px; float: left;   word-wrap: break-word; word-break: break-word;  word-wrap: break-word; word-break: break-word;"
            >
              <div
                data-editorblocktype="SubscriptionListBlock"
                style="text-align: center;"
              >
                <div
                  class="marketing-subscription-list"
                  style="text-align: left;"
                >
                  <input
                    id="e1aca2f6-f349-ec11-8c62-6045bd902f0c"
                    class="lp-form-fieldInput"
                    name="e1aca2f6-f349-ec11-8c62-6045bd902f0c"
                    type="checkbox"
                  /><label
                    class="lp-ellipsis"
                    for="e1aca2f6-f349-ec11-8c62-6045bd902f0c"
                    >Ja, takk jeg ønsker å motta nyhetsbrev fra Novanet.</label
                  >
                </div>
              </div>
            </div>
            <div style="clear:both;"></div>
          </div>
        </div>
        <div data-section="true" class="emptyContainer">
          <div
            style="
            display: flex;
            width: 100%;
        ;flex-wrap: wrap;"
          >
            <div style="clear:both;"></div>
            <div
              id="container2befb9e9f4a0c1679407144660"
              data-container="true"
              class="columnContainer"
              data-container-width="100"
              style="display: block; min-height: 0px; min-width: 0px; width: calc(100% - 0px); box-sizing: border-box; padding: 10px; float: left;     word-wrap: break-word; word-break: break-word;    word-wrap: break-word; word-break: break-word;"
            >
              <div data-editorblocktype="SubmitButtonBlock">
                <p>
                  <button
                    class="lp-form-button lp-form-fieldInput"
                    name="submit"
                    type="submit"
                    @click="submit"
                  >
                    Registrer
                  </button>
                </p>
              </div>
              <div data-editorblocktype="Text" style="text-align: center;">
                <p style="text-align: left;">
                  <span style="font-size: 11px; text-align: center;"
                    >obligatoriske felter er merket med *</span
                  >
                </p>
              </div>
            </div>
            <div style="clear:both;"></div>
          </div>
        </div>
      </div>
    </form> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      firstname: '',
      lastname: ''
    };
  },
  mounted() {
    // const formloaderScript = document.createElement('script');
    // formloaderScript.setAttribute(
    //   'src',
    //   'https://mktdplp102cdn.azureedge.net/public/latest/js/form-loader.js?v=1.84.2007'
    // );
    // document.head.appendChild(formloaderScript);
    // const wstrackingScript = document.createElement('script');
    // wstrackingScript.setAttribute(
    //   'src',
    //   'https://mktdplp102cdn.azureedge.net/public/latest/js/ws-tracking.js?v=1.84.2007'
    // );
    // document.head.appendChild(wstrackingScript);
  },
  methods: {
    submit() {
      this.$emit('submit', {
        email: this.email,
        username: `${this.firstname} ${this.lastname}`
      });
    }
  }
};
</script>

<style scoped>
form {
  font-family: Century Gothic;
}

form .lp-form-fieldInput {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

form div.lp-form-field {
  word-wrap: break-word;
  word-break: break-word;
}

form div.lp-radioButtonsContainer {
  width: 50%;
}

form span.lp-radioButton input {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  margin-top: 3px;
  border-radius: 50%;
}

form div.marketing-customfield input[type='checkbox'],
form div.marketing-field input[type='checkbox'],
form div.marketing-subscription-list input {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-top: 3px;
}

form span.lp-checkboxListItem,
form span.lp-radioButton {
  /* This rule is needed to style all radio button fields. For product constraints each option is defined as input and label wrapped into a span*/
  display: block;
  margin: 2px;
}

form *[data-layout='true'] {
  margin: 0 auto;
  max-width: /* @layout-max-width */ 600px /* @layout-max-width */;
}

form input {
  border-radius: 3px;
  border: 1px solid #333333;
  background-color: #e7f5f2;
  color: black;
  height: 35px;
  margin-top: 8px;
  text-indent: 10px;
  width: 100%;
}
form select {
  border-radius: 3px;
  border: 1px solid #333333;
  height: 35px;
  margin-top: 8px;
  text-indent: 10px;
  width: 100%;
}
form textarea {
  border-radius: 3px;
  border: 1px solid #333333;
  margin-bottom: 8px;
  margin-top: 8px;
  height: 120px;
  overflow: auto;
  width: 100%;
}
form label {
  margin: 0px;
  font-size: 14px;
}
form button[type='submit'],
form div[data-editorblocktype='SubmitButtonBlock'] button {
  font-size: 18px;
  border-radius: 3px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  font: Century Gothic;
  color: #50e3c2;
  background-color: #3b3b3b;
  border: 1px solid #3b3b3b;
  width: 100%;
  padding: 0;
}
form button[type='reset'],
form div[data-editorblocktype='ResetButtonBlock'] button {
  font-size: 18px;
  border-radius: 3px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  color: #323130;
  border: 1px solid #8a8886;
  width: 100%;
  padding: 0;
}
form button[type='submit'],
form button[type='reset'],
form div[data-editorblocktype='SubmitButtonBlock'],
form div[data-editorblocktype='ResetButtonBlock'] {
  margin: 0 auto;
}
form .columnContainer h2 {
  font-size: 16px;
}
::-webkit-input-placeholder,
::-moz-placeholder,
::-ms-input-placeholder ::placeholder {
  font-size: 16px;
}
form .columnContainer h1 {
  font-size: 26px;
}

@media only screen and (max-width: 768px) {
  form .columnContainer {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup.vue